/**
 * @fileoverview Agent definition for storylines-planner-v1.
 *
 * Takes a plot concept and expands it into storylines with beats and
 * story questions — the structural backbone of a story plan.
 *
 * This is the "Storyline Architect" in the split-planner pipeline:
 *   1. storylines-planner-v1 → structural output (this agent)
 *   2. plot-planner (downstream) → writtenPlot from structure
 *   3. character-ideation-v2 (downstream) → suggestedCharacters from structure
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'storylines-planner-v1',
  kind: 'primitive',
  name: 'Storyline Planner',
  description: 'Takes a plot concept and expands it into storylines with beats at structural phases and story questions. Produces the structural backbone for downstream agents (plot narrator, character ideation).',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.plot',
    usedBy: ['use-long-story-planner.ts'],
    usedInWorkflows: ['story-planner-workflow-v1'],
    relatedAgents: ['plot-planner-v1', 'character-ideation-v2'],
  },
  recommendedModels: [
    { modelProvider: 'anthropic', modelName: 'claude-opus-4-5' },
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
    { modelProvider: 'openai', modelName: 'gpt-5.2' },
  ],
};
